import FullTableLayout from './FullTableLayout';
import ProductionJobsTable from '../../components/tables/ProductionJobsTable';
import { FULL_TABLE_PARENTS } from './routes';

/**
 * Production Jobs on its own page.
 *
 * This is the one table whose heading lives in its host page (OrderMonitor)
 * rather than in the component, so the layout supplies the title here —
 * same wording as the card it came from, so it stays recognisable.
 */
const ProductionJobsFull = () => (
  <FullTableLayout
    backTo={FULL_TABLE_PARENTS.orderMonitor}
    backLabel="Order Monitor"
    title="Production Jobs"
    subtitle="All products launched in production — stock vs client, current phase, and stock reservation"
  >
    <ProductionJobsTable fullPage />
  </FullTableLayout>
);

export default ProductionJobsFull;
